import { version } from "../package.json";

declare const __BUNDLE_VERSION__: string;

const bundleVersion =
	typeof __BUNDLE_VERSION__ !== "undefined" && __BUNDLE_VERSION__
		? __BUNDLE_VERSION__
		: version;

export const MINIFY = true;
export const EXTENSION = MINIFY ? ".min.js" : ".js";
export const CDN = "https://nsk-cdn-static.tiendanube.com/";
export const REGISTER_BUNDLE_NAME = `register-${bundleVersion}`;
export const REGISTER_SRC = `${CDN}${REGISTER_BUNDLE_NAME}${EXTENSION}`;
export const INITIALIZER_BUNDLE_NAME = `initializer-${bundleVersion}`;
export const INITIALIZER_SRC = `${CDN}${INITIALIZER_BUNDLE_NAME}${EXTENSION}`;
